import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ManageMemoModel } from '../../../models/centre/manage-memo.model';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { NewMemoUrl } from '../../../shared/urls/newmemo.url';
import { CentreUrl } from '../../../shared/urls/centre.url';
import { NewsModel } from '../../../models/centre/news.models';
import { UserUrl } from '../../../shared/urls/user.url';
@Injectable()
export class ManageMemoService {
    constructor(public baseService: BaseService) { }

    getAllClinicNew(param) {
        const url = NewMemoUrl.GET_MANAGE_MEMO;
        return this.baseService.getData(url, param);
    }

    getMemoById(id) {
        const url = NewMemoUrl.GET_MEMO_BY_ID;
        return this.baseService.getById(url, id);
    }
    getAllCountry(param) {
        const url = NewMemoUrl.GET_ALL_COUNTRY;
        return this.baseService.getData(url, param);
    }
    getAllCentre(param) {
        const url = NewMemoUrl.GET_ALL_CENTRE;
        return this.baseService.getData(url, param);
    }

    getCentre() {
        const url = CentreUrl.GET_CENTRE;
        return this.baseService.getData(url);
    }
    getAllRole() {
        const url = NewMemoUrl.GET_ALL_ROLE;
        return this.baseService.getAll(url);
    }
    removeMemo(id) {
        const url = NewMemoUrl.REMOVE_MEMO.replace('{id}', id);
        return this.baseService.delete(url);
    }

    updateMemo(id: string, formData: FormData) {
        const url = NewMemoUrl.UPDATE_MEMO + `${id}`;
        return this.baseService.upload(url, formData);
    }

    addNewMemo(formData: FormData) {
        const url = NewMemoUrl.ADD_NEW_MEMO;
        return this.baseService.upload(url, formData);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-memo/manage-memo.service.ts